import { InjectionToken } from '@angular/core';
import { Inject } from '@angular/core';
import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { untilDestroyed } from '@ngneat/until-destroy';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AlertType } from 'app/modules/darwin/models/alert';
import { Alert } from 'app/modules/darwin/models/alert';
import { AlertsConfig } from 'app/modules/darwin/models/alerts-config';
import { AlertsService } from 'app/modules/darwin/services/alerts.service';
import { SessionTokenSelectors } from 'app/modules/darwin/store/session-token/session-token.selectors';
import { AccountIdentity } from 'app/modules/main/models/account';
import { UserAuthorizationSelectors } from 'app/modules/main/store/user-authorization/user-authorization.selectors';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
})
export class AlertsComponent implements OnInit {

  static DARWIN_ALERTS_CONFIG =
    new InjectionToken<AlertsConfig>('DARWIN_ALERTS_CONFIG');

  private _alerts: Alert[] = [];

  get alerts(): Alert[] {
    return this._alerts;
  }

  get alertsEnabled(): boolean {
    return this.alertsConfig.enabled;
  }

  constructor(
    private readonly alertsClient: AlertsService,
    private readonly sessionTokenSelectors: SessionTokenSelectors,
    private readonly userAuthorizationSelectors: UserAuthorizationSelectors,
    @Inject(AlertsComponent.DARWIN_ALERTS_CONFIG)
    private readonly alertsConfig: AlertsConfig,
  ) {
  }

  ngOnInit(): void {

    if (!this.alertsEnabled) {
      return;
    }

    this.fetchAlerts();
  }

  closeAlert(
    closedAlert: Alert
  ) {
    this.alertsClient.closeAlert(closedAlert)
      .subscribe(() => {
        this._alerts =
          this._alerts.filter(alerts => closedAlert.remindableKey !== alerts.remindableKey);
      });
  }

  classForType(
    alertType: AlertType
  ): string {
    return 'userMessage userMessage' + alertType;
  }

  private fetchAlerts(): void {

    combineLatest([
      this.userAuthorizationSelectors.getAccount(),
      this.sessionTokenSelectors.getSessionToken(),
    ])
      .pipe(
        untilDestroyed(this),
        first(),
        map(([account, _]) => account),
        switchMap((account: AccountIdentity) => this.alertsClient.fetch(account))
      )
      .subscribe(alerts => this._alerts = alerts);
  }

}
